// src/components/MonthNav.jsx — barre de navigation mois (◀ label ▶).
// Composant pur sans state, utilisé par App.jsx (Données + Facturation) et ComptaTab.
// Pilule fond blanc uniforme — texte marine + chevrons lucide marine (‹ mois ›).

import { ChevronLeft, ChevronRight } from 'lucide-react'
import { DS } from '../lib/ui'

export function MonthNav({ y, m, label, nav }) {
  const arrowBtn = {
    background: "none", border: "none", cursor: "pointer",
    color: DS.marine, display: "flex", alignItems: "center",
    padding: "5px 7px", borderRadius: 8,
  }
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{
        display: "inline-flex", alignItems: "center", gap: 4,
        background: DS.white, border: "1px solid #e8edf4",
        borderRadius: 999, padding: "4px 6px",
        fontFamily: DS.fontBody, maxWidth: "100%",
      }}>
        <button onClick={() => nav(-1)} aria-label="Mois précédent" style={arrowBtn}>
          <ChevronLeft size={20} strokeWidth={2.2} />
        </button>
        <span style={{
          fontFamily: DS.fontDisplay, fontWeight: 700, fontSize: 17,
          color: DS.marine, padding: "0 8px", textAlign: "center",
        }}>{label}</span>
        <button onClick={() => nav(1)} aria-label="Mois suivant" style={arrowBtn}>
          <ChevronRight size={20} strokeWidth={2.2} />
        </button>
      </div>
    </div>
  )
}

export default MonthNav
